import React from 'react';
import { Add } from '@wix/wix-ui-icons-common';
import { Button, ButtonProps } from '@wix/design-system';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';

export type AddNewButtonProps = Omit<
  ButtonProps,
  'priority' | 'size' | 'fullWidth' | 'prefixIcon'
> & { onClick?: any };

/**
 * @deprecated Use primaryActionButton instead.
 */
export function AddNewButton(props: AddNewButtonProps) {
  const { translate: t } = useWixPatternsContainer();
  const { toolbarBIReporter } = useToolbarCollectionContext();

  return (
    <Button
      {...props}
      as="button"
      size="small"
      priority="secondary"
      skin="standard"
      prefixIcon={<Add />}
      dataHook="toolbar-primary-action-button"
      onClick={(event) => {
        toolbarBIReporter.onAddItemClick('Toolbar CTA');
        toolbarBIReporter.onPrimaryActionButtonClick();
        props.onClick?.(event);
      }}
    >
      {props.children ?? t('cairo.collectionsPage.add.item.CTA')}
    </Button>
  );
}
